import { useEffect, useRef } from 'react';

// Granular Refresh spec §2.4. Section-level select-all toggle. Tri-state:
//   - 'all'  → checked
//   - 'some' → indeterminate (native checkbox.indeterminate, set via ref —
//              there is no React prop for it)
//   - 'none' → unchecked
// Clicking always dispatches a single onToggle; the parent decides whether
// that means "select all in section" or "clear the section".

type Props = {
  label: string;
  count: number;
  state: 'all' | 'some' | 'none';
  onToggle: () => void;
};

export function SectionCheckbox({ label, count, state, onToggle }: Props) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = state === 'some';
  }, [state]);

  return (
    <label className="flex cursor-pointer items-center gap-2 border-b border-slate-200 px-4 py-2">
      <input
        ref={ref}
        type="checkbox"
        className="h-4 w-4 rounded border-slate-300"
        checked={state === 'all'}
        onChange={onToggle}
      />
      <span className="text-xs font-semibold uppercase tracking-wide text-slate-600">
        {label} ({count} {count === 1 ? 'field' : 'fields'})
      </span>
    </label>
  );
}
